"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Registration = void 0;
const tslib_1 = require("tslib");
const base_1 = tslib_1.__importDefault(require("../base"));
const utils_1 = tslib_1.__importDefault(require("../utils"));
class Registration extends base_1.default {
    /**
     * Sign up a user for FIDO authentication.
     * @deprecated This method is deprecated, use `registerWithFido2` instead.
     * */
    register(username, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const result = yield this.registerWithFido2(username, options);
            return {
                uid: result.credential.uuid,
                username: result.user.username,
                namespace: result.user.namespace_id,
                jwt: result.jwt,
                user: {
                    id: result.user.id,
                    type: result.user.type,
                }
            };
        });
    }
    /**
     * Sign up a user for FIDO2 authentication.
     * @returns {Promise<Result>}
     * */
    registerWithFido2(username, options = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const session = localStorage.getItem("register_session");
            let headers;
            if (options && options.authorization_token) {
                headers = { Authorization: `Bearer ${options.authorization_token}` };
                delete options.authorization_token;
            }
            // Init the registration flow
            const initPayload = {
                client_id: this._clientID,
                username,
                options: {
                    register_session: session
                },
            };
            // Check for payload options before sending the request.
            if (options && options.roaming_authenticator) {
                initPayload.options.roaming_authenticator = options.roaming_authenticator;
            }
            let initResponse = yield utils_1.default.http.post(this._baseURL, "/register/fido2/init", initPayload, headers);
            // Process the register init response and request the credential creation from the browser
            const { register_session: registerSession, attestation_payload: attestationPayload } = initResponse;
            const { credential_uuid: credentialUUID } = attestationPayload, publicKey = tslib_1.__rest(attestationPayload, ["credential_uuid"]);
            localStorage.setItem("register_session", registerSession);
            const { challenge } = publicKey;
            publicKey.challenge = utils_1.default.encoding.base64ToBuffer(publicKey.challenge);
            publicKey.user.id = utils_1.default.encoding.base64ToBuffer(publicKey.user.id);
            if (publicKey.excludeCredentials) {
                publicKey.excludeCredentials = publicKey.excludeCredentials.map(utils_1.default.navigator.convertCredentialDescriptor);
            }
            const credential = yield utils_1.default.navigator.createCredential({ publicKey });
            const response = credential.response;
            // Complete the registration flow
            const completePayload = {
                client_id: this._clientID,
                username,
                attestation_payload: {
                    challenge,
                    credential_uuid: credentialUUID,
                    credential_id: utils_1.default.encoding.bufferToBase64(credential.rawId),
                    client_data: utils_1.default.encoding.bufferToBase64(response.clientDataJSON),
                    attestation_data: utils_1.default.encoding.bufferToBase64(response.attestationObject),
                }
            };
            // Check for payload options before sending the request.
            if (options && options.credential_name) {
                completePayload.options = { credential_name: options.credential_name };
            }
            // TODO: Check for backward compatibility
            return yield utils_1.default.http.post(this._baseURL, "/register/fido2/complete", completePayload);
        });
    }
    /**
     * Creates a user account with a password.
     * @returns {Promise<Result>}
     * */
    registerWithPassword(username, password, passwordConfirmation, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let headers;
            if (options && options.authorization_token) {
                headers = { Authorization: `Bearer ${options.authorization_token}` };
                delete options.authorization_token;
            }
            // Create the request payload.
            const payload = {
                client_id: this._clientID,
                username,
                password,
                password_confirmation: passwordConfirmation,
            };
            // Check for payload options before sending the request.
            if (options && options.credential_name) {
                payload.options = { credential_name: options.credential_name };
            }
            return yield utils_1.default.http.post(this._baseURL, "/register/password", payload, headers);
        });
    }
    /**
     * Add a FIDO2 credential to an existing user.
     * @returns {Promise<Result>}
     * */
    addFido2CredentialWithCode(username, code, options) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let headers;
            if (options && options.authorization_token) {
                headers = { Authorization: `Bearer ${options.authorization_token}` };
                delete options.authorization_token;
            }
            // Init the add credential flow
            const initPayload = {
                client_id: this._clientID,
                username,
                authentication_code: {
                    code,
                    type: (options === null || options === void 0 ? void 0 : options.code_type) ? options === null || options === void 0 ? void 0 : options.code_type : "short"
                }
            };
            // Check for payload options before sending the request.
            if (options && options.roaming_authenticator) {
                initPayload.options = { roaming_authenticator: options.roaming_authenticator };
            }
            let initResponse = yield utils_1.default.http.post(this._baseURL, "/credentials/fido2/init/code", initPayload, headers);
            // Process the add credential init response and request the credential creation from the browser
            const { attestation_payload: attestationPayload } = initResponse;
            const { credential_uuid: credentialUUID } = attestationPayload, publicKey = tslib_1.__rest(attestationPayload, ["credential_uuid"]);
            const { challenge } = publicKey;
            publicKey.challenge = utils_1.default.encoding.base64ToBuffer(publicKey.challenge);
            publicKey.user.id = utils_1.default.encoding.base64ToBuffer(publicKey.user.id);
            if (publicKey.excludeCredentials) {
                publicKey.excludeCredentials = publicKey.excludeCredentials.map(utils_1.default.navigator.convertCredentialDescriptor);
            }
            const credential = yield utils_1.default.navigator.createCredential({ publicKey });
            const response = credential.response;
            // Complete the add credential flow
            const completePayload = {
                client_id: this._clientID,
                username,
                attestation_payload: {
                    challenge,
                    credential_uuid: credentialUUID,
                    credential_id: utils_1.default.encoding.bufferToBase64(credential.rawId),
                    client_data: utils_1.default.encoding.bufferToBase64(response.clientDataJSON),
                    attestation_data: utils_1.default.encoding.bufferToBase64(response.attestationObject),
                }
            };
            // Check for payload options before sending the request.
            if (options && options.credential_name) {
                completePayload.options = { credential_name: options.credential_name };
            }
            return yield utils_1.default.http.post(this._baseURL, "/credentials/fido2/complete", completePayload);
        });
    }
}
exports.Registration = Registration;
exports.default = Registration;
//# sourceMappingURL=index.js.map